<template>
  <fragment>
    <v-form
      ref="formCard"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 84px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon v-if="formShowAt === 'card'">mdi-plus</v-icon>
            <v-btn icon v-if="formShowAt === 'employee'" @click="onBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มบัตร</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-icon v-if="formShowAt === 'employee'">
            <v-btn icon @click="onBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cardInit.card_type.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ cardInit.card_number }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn v-if="formShowAt === 'card'" icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div style="position: relative">
          <label class="body-2">
            ประเภทบัตร
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            tabindex="1"
            v-model="card.card_type.card_type_uuid"
            :items="cardTypes"
            :rules="[(v) => !!v || 'โปรดระบุประเภทบัตร']"
            item-text="title_th"
            item-value="card_type_uuid"
            outlined
            dense
          >
          </v-autocomplete>
          <v-btn
            style="position: absolute; right: 0; bottom: -4px"
            small
            text
            color="primary"
            @click="showMore = !showMore"
          >
            {{ showMore ? 'แสดงข้อมูลน้อยลง' : 'แสดงข้อมูลเพิ่มเติม' }}
          </v-btn>
        </div>
        <div v-show="showMore">
          <div>
            <label class="body-2">ประเภทวัสดุ</label>
            <v-autocomplete
              class="fix-google-chrome mt-1"
              tabindex="2"
              v-model="card.card_material.card_material_code"
              :items="cardMaterials"
              item-text="title_th"
              item-value="card_material_code"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
          <div>
            <label class="body-2">หมายเลขบัตร</label>
            <v-text-field
              class="fix-google-chrome mt-1"
              tabindex="3"
              v-model="card.card_number"
              clearable
              @change="checkEmpty($event, 'card_number')"
              outlined
              dense
            >
            </v-text-field>
          </div>
        </div>

        <div
          v-if="conflictNumberError"
          class="d-flex align-center justify-space-between"
          style="border: 1px solid red; padding: 2px 10px"
        >
          <div class="red--text">{{ conflictNumberError }}</div>
          <v-btn icon @click="conflictNumberError = ''">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div>
          <CardIdentifierItem
            v-for="(cardIdentifier, index) in card.card_identifiers"
            :key="cardIdentifier.card_identifier_uuid"
            :cardIdentifier="cardIdentifier"
            @handleDisplayEncoding="handleDisplayEncoding"
            @handleDeleteCardIdentifier="handleDeleteCardIdentifier"
            :ref="`childForm${index}`"
            :index="index"
          />
        </div>

        <div class="mt-6">
          <v-btn
            color="primary"
            outlined
            @click="dialogCardIdentifierType = true"
          >
            <v-icon left dark>mdi-plus</v-icon>
            เพิ่มข้อมูลอิเล็กทรอนิกส์
          </v-btn>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isCardDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card:create')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card:update')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
      <v-dialog v-model="dialogCardIdentifierType" width="420" persistent>
        <v-form ref="formCardIdentifierType" lazy-validation>
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              กรุณาเลือกชนิดข้อมูลอิเล็กทรอนิกส์
            </v-card-title>

            <v-card-text class="py-12">
              <v-autocomplete
                class="fix-google-chrome"
                v-model="cardIdentifierType"
                :items="cardIdentifierTypes"
                :rules="[(v) => !!v || 'โปรดระบุชนิดข้อมูลอิเล็กทรอนิกส์']"
                item-text="title"
                item-value="card_identifier_type_code"
                outlined
                dense
                return-object
              >
              </v-autocomplete>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="primary" @click="handleCardIdentifierType">
                ตกลง
              </v-btn>
              <v-btn @click="handleResetCardIdentifierType">ยกเลิก</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <ConfirmDialog
        :dialog="confirmDialogDelete"
        :loading="confirmDialogDeleteLoading"
        :dialogData="confirmDialogDeleteData"
        @cancelConfirmDialog="cancelConfirmDialogDelete"
        @submitConfirmDialog="submitConfirmDialogDelete"
      />
      <ConfirmDialog
        :dialog="confirmDialogDataChange"
        :loading="confirmDialogDataChangeLoading"
        :dialogData="confirmDialogDataChangeData"
        @cancelConfirmDialog="cancelConfirmDialogDataChange"
        @submitConfirmDialog="submitConfirmDialogDataChange"
      />
    </v-form>
  </fragment>
</template>

<script>
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import { mapActions } from 'vuex'

// @ is an alias to /src
import CardIdentifierItem from '@/components/CardIdentifierItem.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
    CardIdentifierItem,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formShowAt: {
      type: String,
      default: '',
    },
    formAction: {
      type: String,
      default: '',
    },
    card: {
      type: Object,
    },
    cardInit: {
      type: Object,
    },
  },
  data() {
    return {
      showMore: false,
      conflictNumberError: '',
      cardIdentifierType: null,
      dialogCardIdentifierType: false,
      cardTypeItems: [],
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isCardIdentifiersDataChange() {
      if (
        JSON.stringify(this.card.card_identifiers) !==
        JSON.stringify(this.cardInit.card_identifiers)
      ) {
        return true
      }
      return false
    },
    isCardDataChange() {
      if (
        this.card.card_type.card_type_uuid !==
          this.cardInit.card_type.card_type_uuid ||
        this.card.card_material.card_material_code !==
          this.cardInit.card_material.card_material_code ||
        this.card.card_number !== this.cardInit.card_number ||
        this.isCardIdentifiersDataChange
      ) {
        this.$emit('isCardDataChange', true)
        return true
      }
      this.$emit('isCardDataChange', false)
      return false
    },
    cardTypes() {
      return this.$store.state.card.cardTypes
    },
    cardIdentifierTypes() {
      return this.$store.state.card.cardIdentifierTypes
    },
    cardMaterials() {
      return this.$store.state.card.cardMaterials
    },
  },
  created() {},
  methods: {
    ...mapActions({
      addCard: 'card/addCard',
      editCard: 'card/editCard',
      deleteCard: 'card/deleteCard',
    }),
    handleCardIdentifierType() {
      if (this.$refs.formCardIdentifierType.validate()) {
        this.card.card_identifiers.push({
          card_identifier_uuid: uuidv4(),
          card_identifier_type: {
            card_identifier_type_code:
              this.cardIdentifierType.card_identifier_type_code,
            title: this.cardIdentifierType.title,
          },
          sn: {
            base_10: undefined,
            base_16: undefined,
            string: undefined,
          },
          default_display_encoding: {
            sn_base_10: false,
            sn_base_16: false,
            sn_string: true,
          },
          is_base_10_16_locked: false,
          issue_datetime: undefined,
          expire_datetime: undefined,
          freeze_datetime: undefined,
          discard_datetime: undefined,
        })
        this.dialogCardIdentifierType = false
        this.cardIdentifierType = null
        this.$refs.formCardIdentifierType.reset()
      }
    },
    handleResetCardIdentifierType() {
      this.dialogCardIdentifierType = false
      this.cardIdentifierType = null
      this.$refs.formCardIdentifierType.reset()
    },
    handleDisplayEncoding(cardIdentifier) {
      const index = this.card.card_identifiers.findIndex(
        (item) =>
          item.card_identifier_uuid === cardIdentifier.card_identifier_uuid
      )

      if (index !== -1) {
        this.card.card_identifiers.splice(index, 1, cardIdentifier)
      }
    },
    handleDeleteCardIdentifier(cardIdentifier) {
      const index = this.card.card_identifiers.findIndex(
        (item) =>
          item.card_identifier_uuid === cardIdentifier.card_identifier_uuid
      )

      if (index !== -1) {
        this.card.card_identifiers.splice(index, 1)
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this.card[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบบัตร',
        value: `${this.card.card_type.title_th} : ${this.card.card_number}`,
        item: this.card,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(card) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteCard({
        company_uuid,
        card_uuid: card.card_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$emit('formActionCompleted', this.formAction)
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      this.conflictNumberError = ''

      if (this.$refs.formCard.validate()) {
        if (this.card.card_identifiers.length > 0) {
          let allValid = true

          // Iterate over dynamic refs to validate each form
          for (let i = 0; i < this.card.card_identifiers.length; i++) {
            const childFormRef = this.$refs[`childForm${i}`]
            if (!childFormRef || !childFormRef[0].validateForm()) {
              allValid = false
            }
          }

          if (allValid) {
            // Handle successful validation (e.g., submit data)
            this.$store.state.loading = true

            const card = {
              card_type_uuid: this.card.card_type.card_type_uuid,
              card_material_code: this.card.card_material.card_material_code,
              card_number: this.card.card_number || null,
              card_identifiers:
                this.card.card_identifiers.length > 0
                  ? this.card.card_identifiers.map((cardIdentifier) => {
                      return {
                        card_identifier_type_code:
                          cardIdentifier.card_identifier_type
                            .card_identifier_type_code,
                        sn: {
                          base_10: cardIdentifier.sn.base_10 || null,
                          base_16: cardIdentifier.sn.base_16 || null,
                          string: cardIdentifier.sn.string || null,
                        },
                        default_display_encoding: {
                          sn_base_10:
                            cardIdentifier.default_display_encoding.sn_base_10,
                          sn_base_16:
                            cardIdentifier.default_display_encoding.sn_base_16,
                          sn_string:
                            cardIdentifier.default_display_encoding.sn_string,
                        },
                        is_base_10_16_locked:
                          cardIdentifier.is_base_10_16_locked,
                        issue_datetime: cardIdentifier.issue_datetime
                          ? moment.utc(cardIdentifier.issue_datetime).format()
                          : null,
                        expire_datetime: cardIdentifier.expire_datetime
                          ? moment.utc(cardIdentifier.expire_datetime).format()
                          : null,
                        freeze_datetime: cardIdentifier.freeze_datetime
                          ? moment.utc(cardIdentifier.freeze_datetime).format()
                          : null,
                        discard_datetime: cardIdentifier.discard_datetime
                          ? moment.utc(cardIdentifier.discard_datetime).format()
                          : null,
                      }
                    })
                  : [],
            }

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              body: card,
            }

            this.addCard(payload)
              .then((card) => {
                this.$store.state.loading = false

                const snackbar = {
                  show: true,
                  color: 'success',
                  timeout: 2000,
                  message: 'เพิ่มข้อมูลสำเร็จ',
                }

                this.$store.commit('SET_SNACKBAR', snackbar)
                this.$emit('formActionCompleted', {
                  formAction: this.formAction,
                  card: {
                    ...card,
                    employee_uuid: this.card.employee_uuid,
                  },
                })
              })
              .catch((error) => {
                this.$store.state.loading = false

                if (error?.response?.data?.status === 409) {
                  this.conflictNumberError = error.response.data.message
                }

                const snackbar = {
                  show: true,
                  color: 'error',
                  timeout: -1,
                  message:
                    error?.response?.data?.message || 'Something went wrong!',
                }
                this.$store.commit('SET_SNACKBAR', snackbar)
              })
          }
        } else {
          this.$store.state.loading = true

          const card = {
            card_type_uuid: this.card.card_type.card_type_uuid,
            card_material_code: this.card.card_material.card_material_code,
            card_number: this.card.card_number || null,
            card_identifiers: [],
          }

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            body: card,
          }

          this.addCard(payload)
            .then((card) => {
              this.$store.state.loading = false

              const snackbar = {
                show: true,
                color: 'success',
                timeout: 2000,
                message: 'เพิ่มข้อมูลสำเร็จ',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              this.$emit('formActionCompleted', {
                formAction: this.formAction,
                card: {
                  ...card,
                  employee_uuid: this.card.employee_uuid,
                },
              })
            })
            .catch((error) => {
              this.$store.state.loading = false

              if (error?.response?.data?.status === 409) {
                this.conflictNumberError = error.response.data.message
              }

              const snackbar = {
                show: true,
                color: 'error',
                timeout: -1,
                message:
                  error?.response?.data?.message || 'Something went wrong!',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            })
        }
      }
    },
    onSave() {
      this.conflictNumberError = ''

      if (this.$refs.formCard.validate()) {
        if (this.card.card_identifiers.length > 0) {
          let allValid = true

          // Iterate over dynamic refs to validate each form
          for (let i = 0; i < this.card.card_identifiers.length; i++) {
            const childFormRef = this.$refs[`childForm${i}`]
            if (!childFormRef || !childFormRef[0].validateForm()) {
              allValid = false
            }
          }

          if (allValid) {
            // Handle successful validation (e.g., submit data)
            this.$store.state.loading = true

            const card = {
              card_type_uuid: this.card.card_type.card_type_uuid,
              card_material_code: this.card.card_material.card_material_code,
              card_number: this.card.card_number || null,
              card_identifiers:
                this.card.card_identifiers.length > 0
                  ? this.card.card_identifiers.map((cardIdentifier) => {
                      return {
                        card_identifier_uuid:
                          cardIdentifier.card_identifier_uuid,
                        card_identifier_type_code:
                          cardIdentifier.card_identifier_type
                            .card_identifier_type_code,
                        sn: {
                          base_10: cardIdentifier.sn.base_10 || null,
                          base_16: cardIdentifier.sn.base_16 || null,
                          string: cardIdentifier.sn.string || null,
                        },
                        default_display_encoding: {
                          sn_base_10:
                            cardIdentifier.default_display_encoding.sn_base_10,
                          sn_base_16:
                            cardIdentifier.default_display_encoding.sn_base_16,
                          sn_string:
                            cardIdentifier.default_display_encoding.sn_string,
                        },
                        is_base_10_16_locked:
                          cardIdentifier.is_base_10_16_locked,
                        issue_datetime: cardIdentifier.issue_datetime
                          ? moment.utc(cardIdentifier.issue_datetime).format()
                          : null,
                        expire_datetime: cardIdentifier.expire_datetime
                          ? moment.utc(cardIdentifier.expire_datetime).format()
                          : null,
                        freeze_datetime: cardIdentifier.freeze_datetime
                          ? moment.utc(cardIdentifier.freeze_datetime).format()
                          : null,
                        discard_datetime: cardIdentifier.discard_datetime
                          ? moment.utc(cardIdentifier.discard_datetime).format()
                          : null,
                      }
                    })
                  : [],
            }

            const { company_uuid } = this.$store.state.authentication.company

            const payload = {
              company_uuid,
              card_uuid: this.card.card_uuid,
              body: card,
            }

            this.editCard(payload)
              .then(() => {
                this.$store.state.loading = false

                const snackbar = {
                  show: true,
                  color: 'success',
                  timeout: 2000,
                  message: 'แก้ไขข้อมูลสำเร็จ',
                }

                this.$store.commit('SET_SNACKBAR', snackbar)
                this.$emit('formActionCompleted', {
                  formAction: this.formAction,
                })
              })
              .catch((error) => {
                this.$store.state.loading = false

                if (error?.response?.data?.status === 409) {
                  this.conflictNumberError = error.response.data.message
                }

                const snackbar = {
                  show: true,
                  color: 'error',
                  timeout: -1,
                  message:
                    error?.response?.data?.message || 'Something went wrong!',
                }
                this.$store.commit('SET_SNACKBAR', snackbar)
              })
          }
        } else {
          this.$store.state.loading = true

          const card = {
            card_type_uuid: this.card.card_type.card_type_uuid,
            card_material_code: this.card.card_material.card_material_code,
            card_number: this.card.card_number || null,
            card_identifiers: [],
          }

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            card_uuid: this.card.card_uuid,
            body: card,
          }

          this.editCard(payload)
            .then(() => {
              this.$store.state.loading = false

              const snackbar = {
                show: true,
                color: 'success',
                timeout: 2000,
                message: 'เพิ่มข้อมูลสำเร็จ',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              this.$emit('formActionCompleted', {
                formAction: this.formAction,
              })
            })
            .catch((error) => {
              this.$store.state.loading = false

              if (error?.response?.data?.status === 409) {
                this.conflictNumberError = error.response.data.message
              }

              const snackbar = {
                show: true,
                color: 'error',
                timeout: -1,
                message:
                  error?.response?.data?.message || 'Something went wrong!',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            })
        }
      }
    },
    onBack() {
      this.conflictNumberError = ''

      if (this.isCardDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
      }
    },
    onClose() {
      this.conflictNumberError = ''

      if (this.isCardDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
      }
    },
    cancelConfirmDialogDataChange() {
      this.conflictNumberError = ''
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.conflictNumberError = ''
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
    },
    onReset() {
      if (this.$refs.formCard) this.$refs.formCard.resetValidation()
      if (this.$refs.formCardIdentifierType) {
        this.$refs.formCardIdentifierType.resetValidation()
      }

      this.conflictNumberError = ''

      this.$emit('onReset', this.formAction)
    },
  },
}
</script>
